import React from 'react';
import { ArrowRightIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from '../ButtonLink';
import { Eyebrow } from '../Eyebrow';
import { Breadcrumbs } from './Breadcrumbs';
import { contact, urls } from '../../data/site';
import type { PageContent } from '../../types/pageContent';
export function ContentIntro({
  page,
  breadcrumbs,
  showActions = true
}: {
  page: PageContent;
  breadcrumbs: {
    label: string;
    path: string;
  }[];
  showActions?: boolean;
}) {
  return <section aria-labelledby="page-heading" className="bg-ink py-8 text-paper md:py-12" data-id="element-170" data-mp="3vo30bn4ztu74">
    <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12" data-id="element-171" data-mp="3vqfset4gtkxw">
      <Breadcrumbs items={breadcrumbs} dark data-id="element-172" data-mp="3qpic6m30n0z1" />
      <div className={`grid gap-10 pb-6 pt-10 md:pb-12 md:pt-14 ${page.image ? 'lg:grid-cols-2 lg:items-center lg:gap-16' : ''}`} data-id="element-173" data-mp="3lpx33iu4tc8l">
        <div className="min-w-0" data-id="element-174" data-mp="1owkdwaqgzg6p">
          <Eyebrow tone="dark" data-id="element-175" data-mp="1owu33w3oxjbc">{page.eyebrow}</Eyebrow>
          <h1 id="page-heading" className="mt-5 max-w-[56rem] font-display text-[46px] font-bold uppercase leading-[0.98] sm:text-[58px] md:text-[72px] lg:text-[76px]" data-id="element-176" data-mp="1jyah5vp3k7iz">{page.h1}</h1>
          <p className="mt-6 max-w-[42rem] text-[17px] leading-relaxed text-steel-light md:text-lg" data-id="element-177" data-mp="1d71vdk01cs5j">{page.intro}</p>
          {showActions && <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-178" data-mp="yb3yu0m79lss">
            <ButtonLink href={urls.quote} trailingIcon={ArrowRightIcon} className="w-full sm:w-[230px]" data-id="element-179" data-mp="138m49h10diw1">Request a Quote</ButtonLink>
            <ButtonLink href={contact.phoneHref} variant="outlineDark" leadingIcon={PhoneIcon} className="w-full sm:w-[230px]" data-id="element-180" data-mp="1qz89z1njir2v">Call {contact.phoneDisplay}</ButtonLink>
          </div>}
        </div>
        {page.image && <figure className="min-w-0" data-id="element-181" data-mp="1h8n20nlz8a7a">
          <div className="relative aspect-[4/3] overflow-hidden bg-ink-soft" data-id="element-182" data-mp="1m7q7g95vcifs">
            <img src={page.image.src} alt={page.image.alt} className="absolute inset-0 h-full w-full object-cover" style={{
              objectPosition: page.image.objectPosition || '50% 50%'
            }} data-id="element-183" data-mp="1m5n7awb058xc" />
          </div>
          {page.image.caption && <figcaption className="mt-3 flex items-start gap-3 text-sm leading-relaxed text-steel-light" data-id="element-184" data-mp="2ok12mohaaspf"><span aria-hidden="true" className="mt-2 h-[2px] w-5 shrink-0 bg-brand" data-id="element-185" data-mp="2jl6k7nn8b65u" />{page.image.caption}</figcaption>}
        </figure>}
      </div>
    </div>
  </section>;
}